import { Tab, Tabs } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ArtistPage from 'commons/ArtistPage';
import TabPanel from 'commons/TabPanel';

import ArtworkCollection from '../ArtworkCollection';
import GalleryArtist from '../GalleryArtist';
import GalleryArtwork from '../GalleryArtwork';
import GalleryExhibition from '../GalleryExhibition';
import SpeedDialNavigation from '../SpeedDialNavigation';

const OriginalTabContent = ({
  classes,
  tabValue,
  handleTabChange,
  getLabel,
  isOwner,
  isCollectorOwner,
  isArtist,
  artworksCount,
  collectionsCount,
  exhibitionCount,
  artistCount,
  userProfile,
  userUuid,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();

  return (
    <>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        className={classes.tabs}
      >
        {isOwner && (
          <Tab
            label={getLabel({
              text: t('all_works'),
              number: artworksCount || '',
            })}
            value={1}
            className={classes.tab}
          />
        )}
        {isCollectorOwner && (
          <Tab
            label={getLabel({
              text: t('artists'),
              number: artistCount || '',
            })}
            value={2}
            className={classes.tab}
          />
        )}
        {isOwner && (
          <Tab
            label={getLabel({
              text: t('collection'),
              number: collectionsCount || '',
            })}
            value={3}
            className={classes.tab}
          />
        )}
        {isArtist && (
          <Tab
            label={t('artist_profile')}
            value={4}
            className={classes.tab}
          />
        )}
        <Tab
          label={getLabel({
            text: t('exhibitions'),
            number: exhibitionCount || '',
          })}
          value={5}
          className={classes.tab}
        />
      </Tabs>

      {isOwner && (
        <TabPanel
          value={tabValue}
          index={1}
        >
          <GalleryArtwork
            isOwner={isOwner}
            isPublicShare={false}
          />
        </TabPanel>
      )}

      {isCollectorOwner && (
        <TabPanel
          value={tabValue}
          index={2}
        >
          <GalleryArtist isPublicShare={false} />
        </TabPanel>
      )}

      {isOwner && (
        <TabPanel
          value={tabValue}
          index={3}
        >
          <ArtworkCollection
            isOwner={isOwner}
            isPublicShare={false}
          />
        </TabPanel>
      )}

      {isArtist && (
        <TabPanel
          value={tabValue}
          index={4}
        >
          <ArtistPage
            userProfile={userProfile}
            artistUuid={id}
            isPublicShare={false}
          />
        </TabPanel>
      )}

      <TabPanel
        value={tabValue}
        index={5}
      >
        <GalleryExhibition
          isOwner={isOwner}
          isPublicShare={false}
          userUuid={userUuid}
        />
      </TabPanel>

      {isOwner && <SpeedDialNavigation />}
    </>
  );
};

export default OriginalTabContent;
